import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-346eefc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-content" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "flex-col-centered selection" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "reportType" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Report Type:")
], -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 1,
  class: "flex-col-centered selection"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contract-id" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "List of Contract IDs:")
], -1))
const _hoisted_8 = {
  key: 2,
  class: "flex-col-centered selection"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "owner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Contract Owner Selection:")
], -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = ["title", "disabled"]

import { ref, onMounted, inject, computed, ComputedRef } from "vue";
// Services
import { IAPILogger } from "@/interfaces/IAPILogger";
import { financialSystemNetworkService } from "@/services/helpers/Helper";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { marketSelection } from "@/services/helpers/Helper";
// Data
import { ContractOwner } from "@/models/CarPurchases/ContractOwner";
import IFileResponse from "@/Interfaces/IFileResponse";
import IGetDataTapeRequest from '@/Interfaces/FundingReports/IGetDataTapeRequest';
// Components
import MarketSelector from '@/components/MarketSelector.vue';
// Misc
import log from "loglevel";
import { AxiosResponse } from "axios";
import { Buffer } from "buffer";
import FundingReportOptions from "@/models/enums/FundingReportOptions";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import PeriodSelector from "@/components/PeriodSelector.vue";
import DatePeriod from "@/types/DatePeriod";
import { downloadManager, euSecuritisationReport } from '@/services/network';
import { authService } from "@/auth/authSingleton";
import { FileDownloadType } from "@/models/enums/FileDownloadTypes";
import { contractOwners as contractOwnersNetworkService } from "@/services/network";

const fileName = "FundingReportsExport.vue";
const downloadOwnerErrorDesc = "Getting Contract Owners"
const downloadErrorDesc = "Downloading Funding Report Export";

enum DownloadFileTypes {
    zip = "zip",
    xml = "xml"
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FundingReports',
  setup(__props) {

log.trace("FundingReportsExport");
const Logger: IAPILogger = inject("Logger")!;

//Error Handling
const contractOwners = ref<ContractOwner[]>([]);
const selectedContractOwner = ref("");
const contractIDs = ref<string>("");
const dateRange = ref<Date[]>();
const selectedPeriod = ref<DatePeriod | null>(null);
const startPeriod = ref(new DatePeriod(new Date(2023, 10 ))); 
const selectedReportType = ref(FundingReportOptions.DATA_TAPE);
const fileResponse = ref<IFileResponse>();
const showingSuccNotifier = ref(false);
const emailAddress = computed(() => {
    return authService.getEmailAddress();
});

onMounted(async () => {
    log.trace("onMounted() Funding Reports Export");
    document.title = 'Funding Reports Export - UV';
    await GetContractOwners();
});

function Reset() {
    dateRange.value = undefined;
}
async function GetContractOwners() {
    log.trace("GetContractOwners()");

    const name = GetContractOwners.name;
    const prefix = name + "()\n";
    var Message = `Getting Contract Owners`;

    log.debug(`${prefix}${Message}`);

    const close = useSpinnerPopup().show();
    try {
        const res = await contractOwnersNetworkService.get()
        contractOwners.value = res.data;
        selectedContractOwner.value = contractOwners.value[0].OwnerId ?? "";
    } catch (error) {
        useNotifierWithErrFormatter().error({
            errorType: downloadOwnerErrorDesc,
            error,
        });
    } finally {
        close();
    }
}
async function Submit() {
    try {
        const reportType = selectedReportType.value;
        const market = marketSelection.value;
        const period = selectedPeriod.value;
        const owner = selectedContractOwner.value;
        const contractIds = contractIDs.value;

        if (!period || !period.isValid()) {
            throw new Error(`'Invalid period selection: ${selectedPeriod.value}'`);
        }
        switch (reportType) {
            case FundingReportOptions.DATA_TAPE:
                SubmitDataTape(market, period, owner);
                break;
            case FundingReportOptions.UTIL_REPORT_DATA:
                SubmitUtilReportData(market, period, contractIds);
                break;
            case FundingReportOptions.ANNEX5:
                SubmitAnnex5(period, owner);
                break;
            case FundingReportOptions.ANNEX12:
                SubmitAnnex12(period, owner);
                break;
            case FundingReportOptions.CALC_REPORTS:
                SubmitCalcReports(period, owner, market);
                break;
                
            default:
                throw new Error(`Invalid Funding Report Export Type received: ${reportType}`);
        }
    } catch (error) {
        useNotifierWithErrFormatter().error({
            errorType: 'Invalid data input',
            error
        });
    }
}
async function SubmitDataTape(market: string, period: DatePeriod, owner: string) {
    const name = SubmitDataTape.name;
    const Message = `Submitting Data Tape export form: ` +
        `Market: ${market}` +
        `Contract owner: ${owner}` +
        `Period: ${period}`;
    const Class = fileName + "/" + name;
    
    Logger.LogInformation(Message, Class);
    await DownloadDataTape(period, market, owner);
}
async function SubmitUtilReportData(market: string, period: DatePeriod, contractIDs: string) {
    const name = SubmitUtilReportData.name;
    const Message = `Submitting Util Report Data export form: ` +
        `Market: ${market}` +
        `Contract IDs: ${contractIDs}` +
        `Period: ${period}`;
    const Class = fileName + "/" + name;
    
    Logger.LogInformation(Message, Class);
    await DownloadUtilReportData(period, market, contractIDs);
}
async function SubmitAnnex5(period: DatePeriod, owner: string) {
    const name = SubmitAnnex5.name;
    const Message = `Submitting Annex 5 export for ${period}`;
    const Class = fileName + "/" + name;

    Logger.LogInformation(Message, Class);
    await DownloadAnnex5(period, owner);
}
async function SubmitAnnex12(period: DatePeriod, owner: string) {
    const name = SubmitAnnex12.name;
    const Message = `Submitting Annex 12 export for ${period}`;
    const Class = fileName + "/" + name;

    Logger.LogInformation(Message, Class);
    await DownloadAnnex12(period, owner);
}
async function DownloadDataTape(period: DatePeriod, market: string, owner: string) {
    log.trace("DownloadDataTape()");

    const name = DownloadDataTape.name;
    const Class = fileName + "/" + name;

    const closeSpinner = useSpinnerPopup().show();
    const urlParams: string =
        process.env.VUE_APP_GET_FUNDING_REPORTS_EXPORT_URL_PARAMS!;

    const reqBody: IGetDataTapeRequest = {
        Owner: owner,
        Market: market,
        PeriodDate: period
    };

    var Message = `Downloading Funding Reports Export files (URL params: ${urlParams})`;

    log.debug(`${name}()\n${Message}`);

    try {
        const res = await financialSystemNetworkService.post(reqBody, urlParams) as AxiosResponse<IFileResponse>;
        fileResponse.value = res.data;
        log.trace(
            "DownloadDataTape()\nfileResponse.Name:",
            fileResponse.value.Name
        );

        MakeDownloadFile(fileResponse.value, DownloadFileTypes.zip);
        Reset();
        showingSuccNotifier.value = true;

        Logger?.LogInformation(Message, Class);
    } catch(error) {
        useNotifierWithErrFormatter().error({
            errorType: downloadErrorDesc,
            error
        });
    } finally {
        closeSpinner();
    }
}
async function DownloadUtilReportData(period: DatePeriod, market: string, contractIDs: string) {
    log.trace("DownloadUtilReportData()");

    const name = DownloadUtilReportData.name;
    const Class = fileName + "/" + name;

    // if the ids need to be separated depending on the backend functionality
    const contractIDStr = contractIDs.split(',').map(x=>x.trim());

    const closeSpinner = useSpinnerPopup().show();
    const urlParams: string =
        process.env.VUE_APP_GET_FUNDING_REPORTS_EXPORT_URL_PARAMS!;

    const reqBody: IGetDataTapeRequest = {
        Market: market,
        PeriodDate: period,
        ContractIDs: contractIDStr
    };

    var Message = `Downloading Funding Reports Export files (URL params: ${urlParams})`;

    log.debug(`${name}()\n${Message}`);

    try {
        const res = await financialSystemNetworkService.post(reqBody, urlParams) as AxiosResponse<IFileResponse>;
        fileResponse.value = res.data;
        log.trace(
            "DownloadUtilReportData()\nfileResponse.Name:",
            fileResponse.value.Name
        );

        MakeDownloadFile(fileResponse.value, DownloadFileTypes.zip);
        Reset();
        showingSuccNotifier.value = true;

        Logger?.LogInformation(Message, Class);
    } catch(error) {
        useNotifierWithErrFormatter().error({
            errorType: downloadErrorDesc,
            error
        });
    } finally {
        closeSpinner();
    }
}
async function DownloadAnnex5(period: DatePeriod, ownerID: string) {
    const closeSpinner = useSpinnerPopup().show();

    try {
        await downloadManager.post({
            userName: emailAddress.value,
            type: FileDownloadType.ANNEXE_5,
            requestData:
            {
                Period: period,
                OwnerId: ownerID
            }
        })
        useNotifierWithErrFormatter().success({
            msg: "Annexe5 was queued for download"
        });
    } catch(error) {
        useNotifierWithErrFormatter().error({
            errorType: "Annexe5 download queue error",
            error,
        });
    } finally {
        closeSpinner();
    }
}
async function SubmitCalcReports(period: DatePeriod, ownerID: string, market: string) {
    const closeSpinner = useSpinnerPopup().show();

    try {
        await downloadManager.post({
            userName: emailAddress.value,
            type: FileDownloadType.CALC_REPORTS,
            requestData:
            {
                Period: period,
                OwnerId: ownerID, 
                Market: market
            }
        })
        useNotifierWithErrFormatter().success({
            msg: "Calc Reports were queued for download"
        });
    } catch(error) {
        useNotifierWithErrFormatter().error({
            errorType: "Calc reports download queue error",
            error,
        });
    } finally {
        closeSpinner();
    }
}
async function DownloadAnnex12(period: DatePeriod, ownerID: string) {
    const closeSpinner = useSpinnerPopup().show();

    try {
        await euSecuritisationReport.download({
            type: 'annexe12',
            period
        }, {
            ownerID
        });
    } catch(error) {
        useNotifierWithErrFormatter().error({
            errorType: "Downloading Annexe12",
            error,
        });
    } finally {
        closeSpinner();
    }
}
const DownloadFundingReportsExportDisabled: ComputedRef<boolean> = computed(() => {
    log.trace("(computed) DownloadFundingReportsExportDisabled");

    switch (selectedReportType.value) {
        case FundingReportOptions.DATA_TAPE:
            log.trace(
                `(computed) DownloadFundingReportsExportDisabled
                \nFundingReportOptions.DATA_TAPE: ${FundingReportOptions.DATA_TAPE}
                \n_export.value.market: ${marketSelection.value}, !!_export.value.market: ${!!marketSelection.value},
                \n_export.value.contractOwner: ${selectedContractOwner.value}, !!_export.value.contractOwner: ${!!selectedContractOwner.value},
                \selectedPeriod.value: ${selectedPeriod.value},
                \nselectedReportType.value: ${selectedReportType.value}, !!selectedReportType.value: ${!!selectedReportType.value}`
            );
            return !(
                !!marketSelection.value
                && !!selectedContractOwner.value
                && !!selectedPeriod.value && selectedPeriod.value.isValid()
                && !!selectedReportType.value
            );
        case FundingReportOptions.UTIL_REPORT_DATA:
            log.trace(
                `(computed) DownloadFundingReportsExportDisabled
                \nFundingReportOptions.UTIL_REPORT_DATA: ${FundingReportOptions.UTIL_REPORT_DATA}
                \n_export.value.market: ${marketSelection.value}, !!_export.value.market: ${!!marketSelection.value},
                \n_export.value.contractIDs: ${contractIDs.value}, !!_export.value.contractIDs: ${!!contractIDs.value},
                \selectedPeriod.value: ${selectedPeriod.value},
                \nselectedReportType.value: ${selectedReportType.value}, !!selectedReportType.value: ${!!selectedReportType.value}`
            );
            return !(
                !!marketSelection.value
                && !!contractIDs.value && contractIDs.value != ""
                && !!selectedPeriod.value && selectedPeriod.value.isValid()
                && !!selectedReportType.value
            );
        case FundingReportOptions.ANNEX5:
            log.trace(
                `(computed) DownloadFundingReportsExportDisabled
                \nFundingReportOptions.ANNEX5: ${FundingReportOptions.ANNEX5}
                \selectedPeriod.value: ${selectedPeriod.value?.toJSON()},
                \nselectedReportType.value: ${selectedReportType.value}, !!selectedReportType.value: ${!!selectedReportType.value}`
            );
            return !(
                !!selectedPeriod.value
                && !!selectedReportType.value
            );
        default:
            log.error(`Invalid Funding Report Export Type received: ${selectedReportType.value}`);
            return false;
    }

});
async function MakeDownloadFile(fileResponse: IFileResponse, downloadFileType: DownloadFileTypes) {
    log.debug(`MakeDownloadFile()\ndownloadFileType: ${downloadFileType} (${DownloadFileTypes[DownloadFileTypes.zip]}, ${DownloadFileTypes[DownloadFileTypes.xml]})`);

    var Message = "Making download file from Funding Reports Export file data";

    const name = MakeDownloadFile.name;
    const Class = fileName + "/" + name;

    var file: Blob;
    switch (downloadFileType) {
        case DownloadFileTypes.zip:
            const byteArray: ArrayBuffer = Buffer.from(fileResponse.Data, "base64");
            file = new Blob([byteArray], { type: `application/${DownloadFileTypes.zip}` });
            break;
        case DownloadFileTypes.xml:
            const xmlData: string = fileResponse.Data;
            file = new Blob([xmlData], { type: `application/${DownloadFileTypes.xml}` });
            break;
        default:
            log.error("Invalid downloadFileType provided: ", downloadFileType);
            file = new Blob();
            break;
    }

    try {
        const url = URL.createObjectURL(file);
        // Create anchor element and set attributes
        const link = document.createElement("a");
        link.href = url;
        link.download = fileResponse.Name;

        // Trigger a click on the anchor element
        link.click();

        // Remove the anchor element
        link.remove();
    } catch (error) {
        useNotifierWithErrFormatter().error({
            errorType: Message,
            error
        });
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "form-container selection-form",
      onSubmit: _withModifiers(Submit, ["prevent"])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedReportType).value = $event)),
            class: "dropdown"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(FundingReportOptions)), (reportType) => {
              return (_openBlock(), _createElementBlock("option", {
                value: reportType[1],
                key: reportType[0]
              }, _toDisplayString(reportType[1]), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, selectedReportType.value]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        (selectedReportType.value === _unref(FundingReportOptions).DATA_TAPE || selectedReportType.value === _unref(FundingReportOptions).UTIL_REPORT_DATA || selectedReportType.value === _unref(FundingReportOptions).CALC_REPORTS)
          ? (_openBlock(), _createBlock(MarketSelector, { key: 0 }))
          : _createCommentVNode("", true),
        (selectedReportType.value == _unref(FundingReportOptions).UTIL_REPORT_DATA)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contractIDs).value = $event)),
                id: "contact-id",
                type: "text",
                placeholder: "Enter Contract ID(s)..."
              }, null, 512), [
                [_vModelText, contractIDs.value]
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedContractOwner).value = $event)),
                class: "dropdown",
                required: ""
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractOwners.value, (contractOwner) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: contractOwner.OwnerId,
                    key: contractOwner.OwnerId
                  }, _toDisplayString(contractOwner.FullName), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, selectedContractOwner.value]
              ])
            ])),
        _createVNode(PeriodSelector, {
          modelValue: selectedPeriod.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedPeriod).value = $event)),
          defaultRefDate: startPeriod.value,
          showTitle: ""
        }, null, 8, ["modelValue", "defaultRefDate"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "submit",
          class: "default-btn",
          title: DownloadFundingReportsExportDisabled.value
                                ? 'Select Market, Contract Owner and Period first.'
                                : `Confirm funding report export (Market: '${_unref(marketSelection)}', Contract Owner: '${selectedContractOwner.value}' Period: '${selectedPeriod.value})`,
          disabled: DownloadFundingReportsExportDisabled.value
        }, " Confirm Export ", 8, _hoisted_11)
      ])
    ], 40, _hoisted_2)
  ]))
}
}

})